/* tslint:disable */
/* eslint-disable */
/**
 * Swagger
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { BitoloMerchants } from './bitolo-merchants';

/**
 *
 * @export
 * @interface Bitolo
 */
export class Bitolo {
    /**
     *
     * @type {string}
     * @memberof Bitolo
     */
    _id: string;
    /**
     *
     * @type {string}
     * @memberof Bitolo
     */
    namespace: string;
    /**
     *
     * @type {string}
     * @memberof Bitolo
     */
    type: string;
    /**
     *
     * @type {BitoloMerchants}
     * @memberof Bitolo
     */
    merchants: BitoloMerchants;
    /**
     *
     * @type {boolean}
     * @memberof Bitolo
     */
    sandbox: boolean;
    /**
     *
     * @type {boolean}
     * @memberof Bitolo
     */
    autoApprove: boolean;
}
